export const pagePermissions = {
  dashboard: { resource: "sourcing_agent", action: "read" },
  leadForm: { resource: "sourcing_lead", action: "create" },
  pendingRegistration: { resource: "sourcing_lead", action: "read" }, 
  pendingTraining: { resource: "sourcing_lead", action: "read" },
  potentialLeads: { resource: "potential_lead", action: "read" },
  agentManagement: { resource: "sourcing_agent", action: "read" }
};